import { getConfig } from '@services/config-service';
import { languageService } from '@services/language-service';
import PropTypes from 'prop-types';
import { createContext, useEffect, useMemo, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

const initialState = {
  isLoaded: false,
  title: '',
  logoCiges: null,
  logoClient: null,
  logoCigesWhite: null,
  logoClientWhite: null,
  home: null,
  mailRequired: true,
  phoneRequired: true,
  cardIdRequired: true,
  cardIdName: 'Dni',
  enableGroups: false,
  cookieLink: '#',
  policyLink: '#',
  socketHost: null,
  socketPort: 6002,
  socketAppKey: null,
  allowRemote: false,
  addAppointmentVt: false,
  userFirst: true,
  showLocation: true,
  recaptcha: false,
  recaptchaPublicKey: '',
  recaptchaPrivateKey: '',
  adminMailRequired: true,
  adminPhoneRequired: true,
  adminCardIdRequired: true,
  incidentManager: false,
  authType: [],
  metroIntegration: false,
  userLogin: 'disable_login',
  frontendUrl: '/',
  backendUrl: '/admin',
  bigAppointmentTable: false,
  socketEncrypted: true,
  socketForceTLS: false,
  enableTwoFactor: false,
  firstLoginMessage: false,
  externalIdEnable: false,
  externalIdRequired: false,
  externalIdText: '',
  loginKeyName: 'Email',
  zebraPrinter: false,
  updateState: false,
};

const handlers = {
  INITIALIZE: (state, action) => ({ ...state, ...action.payload }),
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

export const SettingsContext = createContext({
  ...initialState,
});

export const SettingsProvider = function SettingsProvider(props) {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const { i18n } = useTranslation();

  useEffect(() => {
    const initialize = async () => {
      try {
        const isLoaded = window.localStorage.getItem('isLoaded');
        if (isLoaded === null) {
          const language = await languageService.active();
          language.data.forEach((element) => {
            i18n.addResources(element.id, 'translation', element.translation);
            i18n.addResources(element.id, 'common', {
              id: element.id,
              name: element.name,
              icon: element.icon,
            });
            if (element.default === 1) i18n.changeLanguage(element.id);
          });

          const config = await getConfig();

          dispatch({
            type: 'INITIALIZE',
            payload: {
              isLoaded: true,
              ...config.data
            },
          });
        }
      } catch (err) {
        dispatch({
          type: 'INITIALIZE',
          payload: initialState,
        });
      }
    };

    initialize();
  }, [i18n]);

  const settingsContext = useMemo(
    () => ({
      ...state,
    }),
    [state]
  );

  return <SettingsContext.Provider value={settingsContext}>{children}</SettingsContext.Provider>;
};

SettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const SettingsConsumer = SettingsContext.Consumer;
